import { CloseIcon, FilterIcon } from "@floriday/floriday-icons";
import { Button } from "@mui/material";
import { useAtom, useAtomValue } from "jotai";
import {
  filterSidebarAtom,
  toggleFilterSidebarAtom,
} from "../../atoms/filterSidebarAtom";

function FilterSidebarButton() {
  const open = useAtomValue(filterSidebarAtom);
  const [, setSidebar] = useAtom(toggleFilterSidebarAtom);
  function toggleSidebar() {
    setSidebar();
  }

  return (
    <Button
      variant="outlined"
      onClick={toggleSidebar}
      startIcon={<FilterIcon />}
      size="small"
      color={open ? "primary" : "inherit"}
      endIcon={open && <CloseIcon />}
    >
      Filters
    </Button>
  );
}

export default FilterSidebarButton;
